import { format } from 'date-fns';
export class WCPipes {
    constructor(formatD = format) {
        this.formatD = formatD;
    }
    isDefined(value) {
        return value !== undefined && value !== null;
    }
    formatDate(date, format) {
        if (this.isDefined(date)) {
            date = date > 9999999999 ? date : date * 1000;
            return this.formatD(date, format);
        }
    }
    escapeHtml(value) {
        const regexEscape = /["&'<>`]/g;
        const escapeMap = {
            '"': '&quot;',
            '&': '&amp;',
            "'": '&#x27;',
            '<': '&lt;',
            '>': '&gt;',
            '`': '&#x60;',
        };
        function escape(val) {
            return val.replace(regexEscape, ($0) => {
                return escapeMap[$0];
            });
        }
        if (!this.isDefined(value) || (typeof value !== 'string' && !Array.isArray(value))) {
            return value;
        }
        else {
            if (Array.isArray(value)) {
                return value.map((element) => (typeof value !== 'string' ? escape(element) : element));
            }
            if (typeof value === 'string') {
                return escape(value);
            }
            else {
                return value;
            }
        }
    }
}
